document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.product__media-list');
  if (!slider) return;

  const wrapper = slider.parentElement;
  wrapper.style.position = 'relative';

  const prev = document.createElement('button');
  const next = document.createElement('button');

  prev.textContent = '❮';
  next.textContent = '❯';

  [prev, next].forEach(btn => {
    btn.style.cssText = `
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 99999;
      background: rgba(255,255,255,0.9);
      border: none;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      font-size: 18px;
      cursor: pointer;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      opacity: 0;
      transition: opacity 0.2s;
    `;
  });

  prev.style.left = '30px';
  next.style.right = '30px';

  wrapper.appendChild(prev);
  wrapper.appendChild(next);

  wrapper.addEventListener('mouseenter', () => { prev.style.opacity = '1'; next.style.opacity = '1'; });
  wrapper.addEventListener('mouseleave', () => { prev.style.opacity = '0'; next.style.opacity = '0'; });

  const thumbs = Array.from(document.querySelectorAll('.thumbnail-list__item button'));
  let index = 0;

  function goTo(newIndex) {
    if (newIndex < 0) newIndex = thumbs.length - 1;
    if (newIndex >= thumbs.length) newIndex = 0;
    index = newIndex;
    // Remove zoom overlay if present
    const overlay = document.querySelector('.image-magnify-full-size');
    if (overlay) overlay.remove();
    thumbs[index].dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
  }

  prev.addEventListener('mousedown', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    goTo(index - 1);
  }, true);

  next.addEventListener('mousedown', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    goTo(index + 1);
  }, true);
});